var styleDataHash = 'ffd9c8b6';  
export const injectCss = (() => {
  var css = `@charset "UTF-8";.dSM-R,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.j2upg{position:relative}._0cqkU{--mobile-toolbar-height:47px;--border-top:0px;--border-bottom:0px;--border-left:0px;--border-right:0px}.YBpr3{--mobile-toolbar-height:40px;--border-top:1px;--border-bottom:1px;--border-left:1px;--border-right:1px}.bxqzU{--mobile-toolbar-height:47px;--border-top:0px;--border-bottom:1px;--border-left:0px;--border-right:0px}.gYfr7{box-sizing:border-box;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;font-weight:500;height:var(--mobile-toolbar-height);min-width:100%;overflow-x:scroll;overflow-y:clip;position:relative;width:100%}[dir] .gYfr7{background-color:#fff;border:none;border-radius:var(--ricos-settings-whitebox-border-radius,2px);box-shadow:0 4px 8px 0 rgba(0,0,0,.1);padding:0 4px}.gYfr7::-webkit-scrollbar{display:none}[dir] .ByuNW{border:1px solid rgba(51,51,51,.1);box-shadow:var(--ricos-settings-whitebox-box-shadow,0 4px 8px 0 rgba(0,0,0,.07))}._9susP{position:static}[dir] ._9susP{border-bottom:1px solid rgba(51,51,51,.1);padding:8px 19px}.tyks9{align-items:center;display:flex;grid-column-gap:4px;height:calc(var(--mobile-toolbar-height) - var(--border-top) - var(--border-bottom));width:max-content}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "dSM-R",
  "container": "j2upg",
  "regularContainer": "_0cqkU",
  "floatingContainer": "YBpr3",
  "staticContainer": "bxqzU",
  "mobileToolbar": "gYfr7",
  "toolbarFloating": "ByuNW",
  "toolbarStatic": "_9susP",
  "buttons": "tyks9"
};